module.exports = __webpack_public_path__ + "a5716d90c3d12684e3a2f6938c7edb28.png";